import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CalcInfo, SelectedRangeDataResponse } from './calculations-service.interface';
import {
    SavedScoringModelData,
    SerializedScoringModel,
} from 'CalculationsApp/ts/features/scoring-model-modal/interfaces/scoring-model.interface';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({
    providedIn: 'root',
})
export class CalculationsService {
    constructor(private ajaxService: AjaxService, private urlsService: UrlsService) {}

    getCalcInfo(calcNames: string[]): Observable<CalcInfo> {
        const url = this.urlsService.getUrl(
            this.urlsService.CALCULATIONS.CALC_INFO,
            {},
            { calcs: calcNames.join(',') }
        );
        return this.ajaxService.getDataObserveBody(url);
    }

    getSavedScores(): Observable<SavedScoringModelData[]> {
        const url = this.urlsService.getUrl(this.urlsService.CALCULATIONS.SAVED_SCORE_COLLECTION);
        return this.ajaxService.getDataObserveBody<SavedScoringModelData[]>(url);
    }

    postSavedScore(serializedScore: SerializedScoringModel): Observable<SavedScoringModelData> {
        const url = this.urlsService.getUrl(this.urlsService.CALCULATIONS.SAVED_SCORE_COLLECTION);
        return this.ajaxService.postJsonDataObserveBody<SavedScoringModelData>(url, serializedScore);
    }

    putSavedScore(scoreId: number, serializedScore: SerializedScoringModel): Observable<SavedScoringModelData> {
        const url = this.urlsService.getUrl(this.urlsService.CALCULATIONS.SAVED_SCORE, { scoreId });
        return this.ajaxService.putDataObserveBody<SavedScoringModelData>(url, serializedScore);
    }

    deleteSavedScore(scoreId: number): Observable<{}> {
        const url = this.urlsService.getUrl(this.urlsService.CALCULATIONS.SAVED_SCORE, { scoreId });
        return this.ajaxService.deleteDataObserveBody<{}>(url);
    }

    getMetricRangeInfo(securityGroup: string, metrics: string): Observable<SelectedRangeDataResponse> {
        const url = this.urlsService.getUrl(this.urlsService.CALCULATIONS.METRIC_RANGE_INFO, {
            securityGroup,
            metrics,
        });
        return this.ajaxService.getDataObserveBody(url);
    }
}
